module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-middleware/node_modules/core-js/library/modules/$.library.js
// module id = 260
// module chunks = 1 2 3